import {
  Box,
  Button,
  Flex,
  Table,
  TableContainer,
  Th,
  Thead,
  Tr,
  useToast,
} from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import InputFloating from '../../../components/InputFloating'
import { useMutation, QueryErrorResetBoundary } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { Card } from './Card'
import { api } from '../../../services/api'

const schema = z.object({
  numero_pedido: z.string().min(1, 'Número do pedido é obrigatório'),
})

async function getDataCanhoto({ numero }) {
  const response = await api.get(
    `/site/v2/crm-controle/listar-canhoto-pedido/${numero}`
  )

  return response.data
}

export function VisualizarCanhoto() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const toast = useToast({
    position: 'top',
    isClosable: true,
  })

  const { mutateAsync, data, isLoading } = useMutation({
    mutationFn: getDataCanhoto,
    mutationKey: 'visualizarCanhoto',
    onError: (error) => {
      console.log(error)
      toast({
        title: 'Erro ao visualizar canhoto',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: (data) => {
      console.log(data)
      toast({
        title: 'Canhoto visualizado com sucesso',
        status: 'success',
        duration: 9000,
        isClosable: true,
      })
    },
  })

  async function handleSearch(data) {
    try {
      await mutateAsync({
        numero: data.numero_pedido,
      })
    } catch (error) {
      console.log(error)
    }
  }

  console.log(data)

  return (
    <>
      <HeadingPages name="Visualizar Canhoto" />

      <Layout>
        <Flex
          maxW="550px"
          w="full"
          mx="auto"
          px="6"
          gap={2}
          as="form"
          onSubmit={handleSubmit(handleSearch)}
        >
          <InputFloating
            label="Digite o número do pedido"
            {...register('numero_pedido')}
            error={errors.numero_pedido}
          />
          <Button colorScheme="blue" w="full" maxW="150px" type="submit">
            Visualizar
          </Button>
        </Flex>

        <Box mt="2rem">{data && <Card pedido={data} />}</Box>

        {/* <TableContainer>
          <Table>
            <Thead>
              <Tr>
                <Th>Pedido</Th>
                <Th>Cod. Produto</Th>
                <Th>Numero nota</Th>
                <Th>Numero nfe</Th>
                <Th>Link nota</Th>
                <Th>Produto</Th>
                <Th>Imagem produto</Th>
                <Th>Canhoto</Th>
              </Tr>
            </Thead>
          </Table>
        </TableContainer> */}
      </Layout>
    </>
  )
}
